import { render, staticRenderFns } from "./LayoutDeposit.vue?vue&type=template&id=531cbb34&scoped=true"
import script from "./LayoutDeposit.vue?vue&type=script&lang=js"
export * from "./LayoutDeposit.vue?vue&type=script&lang=js"
import style0 from "./LayoutDeposit.vue?vue&type=style&index=0&id=531cbb34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531cbb34",
  null
  
)

export default component.exports